import ApplicationCard from './ApplicationCard'

export default ApplicationCard
